<template lang="pug">
  .contentpage
    .header-area(v-if="areas.header && areas.header.length")
      section(v-for="(section, index) in areas.header" :key="section.id" :class="section.key" v-if="index === 0")
        Banner(v-if="section.key === 'banner'" :section="section")
        Slider(v-if="section.key === 'slider'" :section="section")
    .main-area(v-if="areas.main && areas.main.length")
      section(v-for="(section, index) in areas.main" :key="section.id" :class="section.key")
        Heading(v-if="section.key === 'heading'" :section="section")
        Post(v-if="section.key === 'post'" :section="section")
        Table(v-if="section.key === 'table'" :section="section")
        Table1(v-if="section.key === 'table1'" :section="section")
        Table2(v-if="section.key === 'table2'" :section="section")
        Table3(v-if="section.key === 'table3'" :section="section")
        Table4(v-if="section.key === 'table4'" :section="section")
        Table5(v-if="section.key === 'table5'" :section="section")

        
</template>

<script>
import Page from '@/views/Page';

import Heading from '@/components/Heading';
import Slider from '@/components/Slider';
import Post from '@/components/Post';
import Banner from '@/components/Banner';
import Table from '@/components/Table';
import Table1 from '@/components/Tabellen/table1';
import Table2 from '@/components/Tabellen/table2';
import Table3 from '@/components/Tabellen/table3';
import Table4 from '@/components/Tabellen/table4';
import Table5 from '@/components/Tabellen/table5';

export default {
    name: 'TablePage',
    extends: Page,
    components: {
        Heading,
        Slider,
        Post,
        Banner,
        Table,
        Table1,
        Table2,
        Table3,
        Table4,
        Table5
    }
};
</script>

<style lang="sass" scoped>
section.slider,
section.banners
  padding: 0
section.heading
  padding-bottom: 0
</style>
